<!--
 * @Description: 园区审核
 * @Date: 2025-09-12 17:49:40
-->
<template>
  <BaseTextTitle class="account-info__items__title">园区审核</BaseTextTitle>
  <BaseTextContent>
    <BaseForm
      class="account-info__items"
      :model="formData"
      disabled
      :column-count="1"
    >
      <template v-if="formData.auditStatus == 24">
        <BaseFormItem label="操作" prop="auditStatus">
          <div>{{ LICENSE_AUDIT_STATUS[formData.auditStatus]?.label }}</div>
        </BaseFormItem>
        <BaseFormItem label="原因类别" prop="auditTerminationReason">
          <div>{{ formData.auditTerminationReason }}</div>
        </BaseFormItem>
        <BaseFormItem label="备注" prop="auditTerminationRemark">
          <div>{{ formData.auditTerminationRemark }}</div>
        </BaseFormItem>
      </template>
      <template v-else>
        <BaseFormItem label="个体户类别" prop="individualType">
          <div>{{ INDIVIDUAL_TYPE[formData.individualType]?.label }}</div>
        </BaseFormItem>
        <BaseFormItem label="意见" prop="individualType">
          <div>{{ LICENSE_AUDIT_STATUS[formData.auditStatus]?.label }}</div>
        </BaseFormItem>
        <!-- 没字段 -->
        <!-- <BaseFormItem label="原因" prop="individualType">
          <div>{{ formData.auditTerminationReason }}</div>
        </BaseFormItem> -->
      </template>
    </BaseForm>
  </BaseTextContent>
</template>

<script lang="ts" setup>
import {
  BaseFormItem,
  BaseTextContent,
  BaseTextTitle,
  BaseForm
} from 'xrk-components';
import { IndividualInfoDetailData } from '../../data-source/types';
import { LICENSE_AUDIT_STATUS, INDIVIDUAL_TYPE } from '../../constants';

const formData = defineModel<IndividualInfoDetailData>();
</script>
